export { SelectOkpd2 } from './SelectOkpd2.js';
export { FormSelectOkpd2 } from './FormSelectOkpd2.js';
